/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Heroic_Turtle_QuellInputs */

const en_plain_heroic_turtle_quell = /** @type {(inputs: Plain_Heroic_Turtle_QuellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Market`)
};

/**
* | output |
* | --- |
* | "Market" |
*
* @param {Plain_Heroic_Turtle_QuellInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const plain_heroic_turtle_quell = /** @type {((inputs?: Plain_Heroic_Turtle_QuellInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Heroic_Turtle_QuellInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_plain_heroic_turtle_quell(inputs)
});